<template>
  <div class="crud-container" data-aos="fade-right">
    <CrudToolbar
      title="Máquinas"
      v-model="filtroTexto"
      searchPlaceholder="Buscar por nombre, marca o serie..."
    >
      <template #actions>
        <button class="btn btn-nuevo btn-header" @click="abrirModal(null)">
          <i class="bi bi-plus-lg"></i>
          <span class="btn-header-texto ms-2">Nueva máquina</span>
        </button>
      </template>
    </CrudToolbar>

    <!-- ══════════════════════ TABLA DESKTOP ══════════════════════ -->
    <div class="divisan-table-container shadow-lg d-none d-lg-block">
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-verde"></div>
        <p class="text-cafe mt-2">Cargando máquinas...</p>
      </div>

      <table v-else class="table table-divisan align-middle mb-0">
        <thead>
          <tr>
            <th class="ps-4">
              <ColumnFilterMenu
                field="nombre"
                label="Nombre"
                :filterable="false"
                :items="maquinasFiltradas"
                :sortField="ordenCampo"
                :sortAsc="ordenAsc"
                @update:sort="onSort"
              />
            </th>
            <th>
              <ColumnFilterMenu
                field="marca"
                label="Marca"
                :filterable="false"
                :items="maquinasFiltradas"
                :sortField="ordenCampo"
                :sortAsc="ordenAsc"
                @update:sort="onSort"
              />
            </th>
            <th>
              <ColumnFilterMenu
                field="serie"
                label="Serie"
                :filterable="false"
                :items="maquinasFiltradas"
                :sortField="ordenCampo"
                :sortAsc="ordenAsc"
                @update:sort="onSort"
              />
            </th>
            <th>
              <ColumnFilterMenu
                field="area"
                label="Área"
                :items="maquinasBuscadas"
                :sortField="ordenCampo"
                :sortAsc="ordenAsc"
                :modelValue="filtroAreaSet"
                @update:modelValue="filtroAreaSet = $event"
                @update:sort="onSort"
              />
            </th>
            <th class="text-center">
              <ColumnFilterMenu
                field="criticidad"
                label="Criticidad"
                :items="maquinasBuscadas"
                :sortField="ordenCampo"
                :sortAsc="ordenAsc"
                :modelValue="filtroCriticidadSet"
                @update:modelValue="filtroCriticidadSet = $event"
                @update:sort="onSort"
              />
            </th>
            <th class="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="maq in maquinasPaginadas" :key="maq.id">
            <td class="ps-4">
              <span class="fw-bold text-cafe">{{ maq.nombre }}</span>
            </td>
            <td>
              <span class="marca-nombre">{{ maq.marca }}</span>
            </td>
            <td>
              <span class="serie-numero">{{ maq.serie || "—" }}</span>
            </td>
            <td>
              <span class="delta-texto">{{ maq.area }}</span>
            </td>
            <td class="text-center">
              <span :class="['badge-criticidad', maq.criticidad?.toLowerCase()]">
                {{ maq.criticidad }}
              </span>
            </td>
            <td class="text-center">
              <div class="d-flex justify-content-center gap-2">
                <button
                  class="btn-circular"
                  @click="abrirModalDetalle(maq)"
                  title="Ver detalle"
                >
                  <i class="bi bi-eye text-dark"></i>
                </button>
                <button class="btn-circular" @click="abrirModal(maq)" title="Editar">
                  <i class="bi bi-pencil-square text-verde"></i>
                </button>
                <button
                  class="btn-circular text-danger"
                  @click="confirmarEliminar(maq)"
                  title="Desactivar"
                >
                  <i class="bi bi-trash3-fill"></i>
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="maquinasPaginadas.length === 0">
            <td colspan="6" class="text-center py-5 text-cafe opacity-50 fw-bold">
              No se encontraron resultados
            </td>
          </tr>
        </tbody>
      </table>

      <div class="paginacion-wrapper">
        <div class="pag-izq">
          <small class="pag-info"
            >{{ rangoInicio }}–{{ rangoFin }} de
            {{ maquinasOrdenadas.length }} máquinas</small
          >
          <div class="por-pagina-wrap">
            <label class="por-pagina-label">Filas:</label>
            <select
              class="por-pagina-select"
              :value="paginacionStore.porPagina"
              @change="cambiarPorPagina(Number($event.target.value))"
            >
              <option v-for="n in paginacionStore.opcionesPorPagina" :key="n" :value="n">
                {{ n }}
              </option>
            </select>
          </div>
        </div>
        <div class="pag-der">
          <button
            class="btn-pag"
            :disabled="paginaActual === 1"
            @click="paginaActual = 1"
          >
            <i class="bi bi-chevron-double-left"></i>
          </button>
          <button class="btn-pag" :disabled="paginaActual === 1" @click="paginaActual--">
            <i class="bi bi-chevron-left"></i>
          </button>
          <template v-for="p in paginasVisibles" :key="p">
            <span v-if="p === '...'" class="pag-ellipsis">…</span>
            <button
              v-else
              :class="['btn-pag-num', { activo: p === paginaActual }]"
              @click="paginaActual = p"
            >
              {{ p }}
            </button>
          </template>
          <button
            class="btn-pag"
            :disabled="paginaActual === totalPaginas"
            @click="paginaActual++"
          >
            <i class="bi bi-chevron-right"></i>
          </button>
          <button
            class="btn-pag"
            :disabled="paginaActual === totalPaginas"
            @click="paginaActual = totalPaginas"
          >
            <i class="bi bi-chevron-double-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- ══════════════════════ CARDS MÓVIL ══════════════════════ -->
    <div class="d-lg-none">
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-verde"></div>
      </div>
      <div
        v-else
        v-for="maq in maquinasPaginadas"
        :key="'mob-' + maq.id"
        class="divisan-mobile-card mb-3 p-3 shadow-sm"
      >
        <div class="d-flex justify-content-between align-items-center mb-2">
          <span class="fw-bold text-cafe fs-5">{{ maq.nombre }}</span>
          <span :class="['badge-criticidad', maq.criticidad?.toLowerCase()]">{{
            maq.criticidad
          }}</span>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-6">
            <label class="small text-muted d-block">Marca</label>
            <span class="marca-nombre">{{ maq.marca }}</span>
          </div>
          <div class="col-6">
            <label class="small text-muted d-block">Serie</label>
            <span class="serie-numero">{{ maq.serie || "—" }}</span>
          </div>
        </div>
        <div class="mb-2">
          <label class="small text-muted d-block">Área</label>
          <span class="delta-texto">{{ maq.area }}</span>
        </div>
        <div class="d-flex justify-content-end gap-3 pt-2 border-top">
          <i class="bi bi-eye text-dark fs-5" @click="abrirModalDetalle(maq)"></i>
          <i class="bi bi-pencil-square text-verde fs-5" @click="abrirModal(maq)"></i>
          <i
            class="bi bi-trash3-fill text-danger fs-5"
            @click="confirmarEliminar(maq)"
          ></i>
        </div>
      </div>

      <!-- Paginación móvil -->
      <div class="paginacion-mobile">
        <div class="pag-mobile-top">
          <small class="pag-info"
            >{{ rangoInicio }}–{{ rangoFin }} de {{ maquinasOrdenadas.length }}</small
          >
          <div class="por-pagina-wrap">
            <label class="por-pagina-label">Filas:</label>
            <select
              class="por-pagina-select"
              :value="paginacionStore.porPagina"
              @change="cambiarPorPagina(Number($event.target.value))"
            >
              <option v-for="n in paginacionStore.opcionesPorPagina" :key="n" :value="n">
                {{ n }}
              </option>
            </select>
          </div>
        </div>
        <div class="pag-mobile-nav">
          <button
            class="btn-pag-mobile"
            :disabled="paginaActual === 1"
            @click="paginaActual--"
          >
            <i class="bi bi-chevron-left"></i> Anterior
          </button>
          <small class="text-verde fw-bold"
            >{{ paginaActual }} / {{ totalPaginas }}</small
          >
          <button
            class="btn-pag-mobile"
            :disabled="paginaActual === totalPaginas"
            @click="paginaActual++"
          >
            Siguiente <i class="bi bi-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- ══════════════════════ MODAL CREAR / EDITAR ══════════════════════ -->
    <div class="modal fade" id="modalMaquina" tabindex="-1" ref="modalElement">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content divisan-modal border-0">
          <div class="modal-header border-0 pb-0">
            <h5 class="fw-bold text-cafe">
              {{ editando ? "Editar máquina" : "Nueva máquina" }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <form @submit.prevent="guardarMaquina" class="modal-form-scrollable">
            <div class="modal-body">
              <div class="row g-3">
                <div class="col-12 col-md-6">
                  <label class="form-label label-divisan">Nombre de la máquina</label>
                  <input
                    v-model="form.nombre"
                    type="text"
                    class="form-control divisan-input-modal"
                    placeholder="Ej. Inyectora 1"
                    required
                  />
                </div>
                <div class="col-12 col-md-6">
                  <label class="form-label label-divisan">Marca</label>
                  <input
                    v-model="form.marca"
                    type="text"
                    class="form-control divisan-input-modal"
                    placeholder="Ej. Engel"
                    required
                  />
                </div>
                <div class="col-12 col-md-6">
                  <label class="form-label label-divisan">Número de serie</label>
                  <input
                    v-model="form.serie"
                    type="text"
                    class="form-control divisan-input-modal"
                    placeholder="Ej. SN-00123"
                  />
                </div>
                <div class="col-12 col-md-6">
                  <label class="form-label label-divisan">Área</label>
                  <input
                    v-model="form.area"
                    type="text"
                    class="form-control divisan-input-modal"
                    placeholder="Ej. Producción, Mantenimiento"
                    required
                  />
                </div>
                <div class="col-12 col-md-6" v-click-outside="cerrarCriticidad">
                  <label class="form-label label-divisan">Criticidad</label>
                  <div class="custom-select-wrapper">
                    <div
                      class="form-control divisan-input-modal custom-select-input criticidad-display"
                      @click="abiertoCriticidad = !abiertoCriticidad"
                    >
                      <span v-if="form.criticidad === 'Alta'">🔴 Alta</span>
                      <span v-else-if="form.criticidad === 'Media'">🟡 Media</span>
                      <span v-else-if="form.criticidad === 'Baja'">🟢 Baja</span>
                      <span v-else class="text-muted">Seleccionar...</span>
                    </div>
                    <i
                      class="bi custom-select-arrow"
                      :class="abiertoCriticidad ? 'bi-chevron-up' : 'bi-chevron-down'"
                      @mousedown.prevent="abiertoCriticidad = !abiertoCriticidad"
                      style="pointer-events: auto; cursor: pointer"
                    ></i>
                    <div v-if="abiertoCriticidad" class="custom-dropdown">
                      <div
                        v-for="op in criticidades"
                        :key="op.value"
                        class="custom-dropdown-item"
                        :class="{ selected: form.criticidad === op.value }"
                        @mousedown.prevent="elegirCriticidad(op.value)"
                      >
                        {{ op.label }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <hr class="border-verde" />
                </div>

                <!-- ── Imágenes ── -->
                <div class="col-12 col-md-6">
                  <label class="form-label label-divisan">
                    <i class="bi bi-images me-1"></i>Imágenes de la máquina
                  </label>
                  <input
                    type="file"
                    @change="handleImagenes"
                    multiple
                    accept="image/*"
                    class="form-control divisan-input-modal"
                  />
                  <small class="text-cafe opacity-75"
                    >Puedes seleccionar varias imágenes.</small
                  >

                  <!-- Imágenes existentes (solo en edición) -->
                  <div
                    v-if="editando && form.imagenes?.length"
                    class="mt-2 d-flex flex-column gap-2"
                  >
                    <div
                      v-for="img in form.imagenes.filter(
                        (i) => !imagenesAEliminar.includes(i.id)
                      )"
                      :key="img.id"
                      class="d-flex align-items-center justify-content-between px-3 py-2 archivo-existente"
                    >
                      <span class="text-verde fw-bold small">
                        <i class="bi bi-image me-1"></i>Imagen
                        {{ form.imagenes.indexOf(img) + 1 }}
                      </span>
                      <button
                        type="button"
                        class="btn-quitar"
                        @click="marcarEliminarImagen(img.id)"
                      >
                        <i class="bi bi-trash3 me-1"></i>Quitar
                      </button>
                    </div>
                  </div>
                </div>

                <!-- ── Manual PDF ── -->
                <div class="col-12 col-md-6">
                  <label class="form-label label-divisan">
                    <i class="bi bi-file-earmark-pdf me-1"></i>Manual técnico (PDF)
                  </label>
                  <input
                    type="file"
                    @change="handleManual"
                    accept="application/pdf"
                    class="form-control divisan-input-modal"
                  />

                  <!-- Manuales existentes (solo en edición) -->
                  <div
                    v-if="editando && form.manuales?.length"
                    class="mt-2 d-flex flex-column gap-2"
                  >
                    <div
                      v-for="man in form.manuales.filter(
                        (m) => !manualesAEliminar.includes(m.id)
                      )"
                      :key="man.id"
                      class="d-flex align-items-center justify-content-between px-3 py-2 archivo-existente"
                    >
                      <a
                        :href="man.documento"
                        target="_blank"
                        class="text-verde fw-bold small"
                      >
                        <i class="bi bi-file-earmark-pdf me-1"></i>Manual
                        {{ form.manuales.indexOf(man) + 1 }}
                      </a>
                      <button
                        type="button"
                        class="btn-quitar"
                        @click="marcarEliminarManual(man.id)"
                      >
                        <i class="bi bi-trash3 me-1"></i>Quitar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer border-0 pt-0">
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
              <button type="submit" class="btn btn-nuevo py-2 px-4" :disabled="guardando">
                <span
                  v-if="guardando"
                  class="spinner-border spinner-border-sm me-2"
                ></span>
                {{ editando ? "Actualizar" : "Guardar máquina" }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- ══════════════════════ MODAL DETALLE ══════════════════════ -->
    <div
      class="modal fade"
      id="modalDetalleMaquina"
      tabindex="-1"
      ref="modalDetalleElement"
    >
      <div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content divisan-modal border-0">
          <div class="modal-header border-0 pb-1">
            <div>
              <h5 class="fw-bold text-cafe mb-1">{{ seleccionada?.nombre }}</h5>
              <span
                :class="['badge-criticidad', seleccionada?.criticidad?.toLowerCase()]"
              >
                {{ seleccionada?.criticidad }}
              </span>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body pt-2">
            <div class="detalle-grid mb-3">
              <div>
                <span class="detalle-mini-label">Marca</span>
                <div class="detalle-mini-valor">{{ seleccionada?.marca || "—" }}</div>
              </div>
              <div>
                <span class="detalle-mini-label">Serie</span>
                <div class="detalle-mini-valor">{{ seleccionada?.serie || "—" }}</div>
              </div>
              <div>
                <span class="detalle-mini-label">Área</span>
                <div class="detalle-mini-valor">{{ seleccionada?.area || "—" }}</div>
              </div>
              <div>
                <span class="detalle-mini-label">Criticidad</span>
                <div class="detalle-mini-valor">
                  {{ seleccionada?.criticidad || "—" }}
                </div>
              </div>
            </div>

            <div v-if="seleccionada?.imagenes?.length" class="detalle-seccion mb-3">
              <span class="detalle-mini-label">Imágenes</span>
              <div
                id="carouselMaquina"
                class="carousel slide mt-2"
                data-bs-ride="carousel"
              >
                <div class="carousel-inner rounded-3">
                  <div
                    v-for="(img, idx) in seleccionada.imagenes"
                    :key="idx"
                    :class="['carousel-item', { active: idx === 0 }]"
                  >
                    <img
                      :src="img.imagen"
                      class="d-block w-100 object-fit-cover"
                      style="height: 220px"
                    />
                  </div>
                </div>
                <button
                  class="carousel-control-prev"
                  type="button"
                  data-bs-target="#carouselMaquina"
                  data-bs-slide="prev"
                >
                  <span class="carousel-control-prev-icon"></span>
                </button>
                <button
                  class="carousel-control-next"
                  type="button"
                  data-bs-target="#carouselMaquina"
                  data-bs-slide="next"
                >
                  <span class="carousel-control-next-icon"></span>
                </button>
              </div>
            </div>
            <div v-else class="detalle-seccion mb-3">
              <span class="detalle-mini-label">Imágenes</span>
              <div class="detalle-mini-valor opacity-50">Sin imágenes registradas</div>
            </div>

            <div class="detalle-seccion">
              <span class="detalle-mini-label">Manuales técnicos</span>
              <div
                v-if="seleccionada?.manuales?.length"
                class="mt-1 d-flex flex-column gap-2"
              >
                <a
                  v-for="(man, idx) in seleccionada.manuales"
                  :key="idx"
                  :href="man.documento"
                  target="_blank"
                  class="btn btn-sm btn-exportar"
                >
                  <i class="bi bi-file-earmark-pdf me-1"></i> Manual {{ idx + 1 }}
                </a>
              </div>
              <div v-else class="detalle-mini-valor opacity-50">
                Sin manuales registrados
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import {
  getMaquinas,
  crearMaquina,
  actualizarMaquina,
  eliminarMaquina,
  agregarImagenMaquina,
  agregarManualMaquina,
  eliminarManualMaquina,
  eliminarImagenMaquina,
} from "@/utils/api_backend";
import { Modal } from "bootstrap";
import Swal from "sweetalert2";
import { usePaginacionMaquinasStore } from "@/store/paginacionStore";
import CrudToolbar from "@/components/Shared/CrudToolbar.vue";
import ColumnFilterMenu from "@/components/Shared/ColumnFilterMenu.vue";

const paginacionStore = usePaginacionMaquinasStore();

const maquinas = ref([]);
const loading = ref(false);
const guardando = ref(false);
const editando = ref(false);
const seleccionada = ref(null);
const selectedImagenes = ref([]);
const selectedManual = ref(null);

// FIX: listas de IDs a eliminar al guardar
const manualesAEliminar = ref([]);
const imagenesAEliminar = ref([]);

const filtroTexto = ref("");
const filtroAreaSet = ref(new Set());
const filtroCriticidadSet = ref(new Set());
const paginaActual = ref(1);
const ordenCampo = ref("nombre");
const ordenAsc = ref(true);

function onSort({ field, asc }) {
  ordenCampo.value = field;
  ordenAsc.value = asc;
  paginaActual.value = 1;
}

const modalElement = ref(null);
const modalDetalleElement = ref(null);
let modalInstance = null;
let modalDetalleInstance = null;

function marcarEliminarManual(id) {
  manualesAEliminar.value.push(id);
}
function marcarEliminarImagen(id) {
  imagenesAEliminar.value.push(id);
}

// ── Dropdown criticidad (modal) ───────────────────────────
const abiertoCriticidad = ref(false);
const criticidades = [
  { value: "Alta", label: "🔴 Alta" },
  { value: "Media", label: "🟡 Media" },
  { value: "Baja", label: "🟢 Baja" },
];
function elegirCriticidad(v) {
  form.value.criticidad = v;
  abiertoCriticidad.value = false;
}
function cerrarCriticidad() {
  abiertoCriticidad.value = false;
}

// ── Directiva click-outside ───────────────────────────────
const vClickOutside = {
  mounted(el, b) {
    el._co = (e) => {
      if (!el.contains(e.target)) b.value(e);
    };
    document.addEventListener("click", el._co);
  },
  unmounted(el) {
    document.removeEventListener("click", el._co);
  },
};

const formVacio = () => ({
  id: null,
  nombre: "",
  marca: "",
  serie: "",
  area: "",
  criticidad: "",
  manuales: [],
  imagenes: [],
});
const form = ref(formVacio());

watch([filtroTexto, filtroAreaSet, filtroCriticidadSet], () => {
  paginaActual.value = 1;
});

const maquinasBuscadas = computed(() => {
  const q = filtroTexto.value.toLowerCase();
  return maquinas.value.filter(
    (m) =>
      !q ||
      m.nombre.toLowerCase().includes(q) ||
      (m.marca || "").toLowerCase().includes(q) ||
      (m.serie || "").toLowerCase().includes(q)
  );
});

const maquinasFiltradas = computed(() =>
  maquinasBuscadas.value.filter(
    (m) =>
      (!filtroAreaSet.value.size || filtroAreaSet.value.has(m.area)) &&
      (!filtroCriticidadSet.value.size || filtroCriticidadSet.value.has(m.criticidad))
  )
);

const maquinasOrdenadas = computed(() =>
  [...maquinasFiltradas.value].sort((a, b) => {
    const va = (a[ordenCampo.value] || "").toString().toLowerCase();
    const vb = (b[ordenCampo.value] || "").toString().toLowerCase();
    if (va < vb) return ordenAsc.value ? -1 : 1;
    if (va > vb) return ordenAsc.value ? 1 : -1;
    return 0;
  })
);

const totalPaginas = computed(() =>
  Math.max(1, Math.ceil(maquinasOrdenadas.value.length / paginacionStore.porPagina))
);

const maquinasPaginadas = computed(() => {
  const inicio = (paginaActual.value - 1) * paginacionStore.porPagina;
  return maquinasOrdenadas.value.slice(inicio, inicio + paginacionStore.porPagina);
});

const rangoInicio = computed(() =>
  maquinasOrdenadas.value.length === 0
    ? 0
    : (paginaActual.value - 1) * paginacionStore.porPagina + 1
);
const rangoFin = computed(() =>
  Math.min(paginaActual.value * paginacionStore.porPagina, maquinasOrdenadas.value.length)
);
const paginasVisibles = computed(() => {
  const total = totalPaginas.value;
  const actual = paginaActual.value;
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const set = new Set([1, total, actual]);
  if (actual > 1) set.add(actual - 1);
  if (actual < total) set.add(actual + 1);
  const ordenadas = [...set].sort((a, b) => a - b);
  const resultado = [];
  for (let i = 0; i < ordenadas.length; i++) {
    if (i > 0 && ordenadas[i] - ordenadas[i - 1] > 1) resultado.push("...");
    resultado.push(ordenadas[i]);
  }
  return resultado;
});

function cambiarPorPagina(n) {
  paginacionStore.setPorPagina(n);
  paginaActual.value = 1;
}

function cambiarPagina(p) {
  if (p >= 1 && p <= totalPaginas.value) paginaActual.value = p;
}

async function cargarMaquinas() {
  loading.value = true;
  try {
    maquinas.value = await getMaquinas();
  } catch {
    Swal.fire("Error", "No se pudo conectar con el servidor", "error");
  } finally {
    loading.value = false;
  }
}

function abrirModal(maquina = null) {
  selectedImagenes.value = [];
  selectedManual.value = null;
  // FIX: limpiar listas de eliminación al abrir
  manualesAEliminar.value = [];
  imagenesAEliminar.value = [];

  if (maquina) {
    editando.value = true;
    form.value = {
      id: maquina.id,
      nombre: maquina.nombre,
      marca: maquina.marca,
      serie: maquina.serie,
      area: maquina.area,
      criticidad: maquina.criticidad,
      // FIX: cargar los archivos existentes para mostrarlos en el modal
      manuales: maquina.manuales || [],
      imagenes: maquina.imagenes || [],
    };
  } else {
    editando.value = false;
    form.value = formVacio();
  }
  modalInstance?.show();
}

function handleImagenes(e) {
  selectedImagenes.value = Array.from(e.target.files);
}
function handleManual(e) {
  selectedManual.value = e.target.files[0] || null;
}

async function guardarMaquina() {
  guardando.value = true;
  try {
    let savedId;
    if (editando.value) {
      // FIX: payload limpio sin manuales/imagenes (son read_only en el serializer)
      await actualizarMaquina(form.value.id, {
        nombre: form.value.nombre,
        marca: form.value.marca,
        serie: form.value.serie,
        area: form.value.area,
        criticidad: form.value.criticidad,
      });
      savedId = form.value.id;
    } else {
      const created = await crearMaquina({
        nombre: form.value.nombre,
        marca: form.value.marca,
        serie: form.value.serie,
        area: form.value.area,
        criticidad: form.value.criticidad,
      });
      savedId = created.id;
    }

    // Subir nuevas imágenes y manual
    for (const img of selectedImagenes.value) await agregarImagenMaquina(savedId, img);
    if (selectedManual.value) await agregarManualMaquina(savedId, selectedManual.value);

    // FIX: eliminar los archivos marcados para borrar
    for (const mid of manualesAEliminar.value) await eliminarManualMaquina(savedId, mid);
    for (const iid of imagenesAEliminar.value) await eliminarImagenMaquina(savedId, iid);

    await cargarMaquinas();
    modalInstance.hide();
    Swal.fire({
      icon: "success",
      title: "Operación exitosa",
      text: `Máquina ${editando.value ? "actualizada" : "creada"} correctamente`,
      timer: 2000,
      showConfirmButton: false,
    });
  } catch {
    Swal.fire("Error", "Ocurrió un problema al procesar la solicitud", "error");
  } finally {
    guardando.value = false;
  }
}

function abrirModalDetalle(maquina) {
  seleccionada.value = maquina;
  modalDetalleInstance?.show();
}

async function confirmarEliminar(maquina) {
  const result = await Swal.fire({
    title: `¿Desactivar ${maquina.nombre}?`,
    text:
      "La máquina y su historial permanecerán, pero no aparecerá en los catálogos activos.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "var(--d-brown)",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Sí, desactivar",
    cancelButtonText: "Cancelar",
  });
  if (result.isConfirmed) {
    try {
      await eliminarMaquina(maquina.id);
      await cargarMaquinas();
      Swal.fire({
        icon: "success",
        title: "Desactivada",
        text: "La máquina ha sido deshabilitada.",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch {
      Swal.fire("Error", "No se pudo desactivar la máquina.", "error");
    }
  }
}

onMounted(() => {
  cargarMaquinas();
  modalInstance = new Modal(modalElement.value);
  modalDetalleInstance = new Modal(modalDetalleElement.value);
});
</script>

<style scoped>
.text-cafe {
  color: var(--d-brown);
}

.text-verde {
  color: var(--d-green);
}

.border-verde {
  border-color: var(--d-green) !important;
}

.btn-nuevo {
  background-color: var(--d-brown);
  color: var(--d-cream);
  border: none;
  font-weight: 600;
}

.btn-nuevo:hover:not(:disabled) {
  background-color: #703808;
  color: var(--d-cream);
}

.btn-exportar {
  background-color: var(--d-green);
  color: var(--d-cream);
  border: none;
  font-weight: 600;
}

.btn-exportar:hover {
  background-color: var(--d-green-dark);
  color: var(--d-cream);
}

.divisan-table-container {
  background-color: var(--d-cream);
  border-radius: 15px;
  overflow: hidden;
}

.table-divisan thead th {
  background: var(--d-cream);
  color: var(--d-brown);
  border-bottom: 3px solid var(--d-brown);
  padding: 15px;
  font-weight: 800;
  text-transform: capitalize;
  border-top: none;
}

.table-divisan td {
  border-bottom: 1px solid rgba(96, 108, 56, 0.1);
  padding: 12px;
}

.marca-nombre {
  font-weight: 700;
  color: var(--d-brown);
  font-size: 0.9rem;
}

.serie-numero {
  font-size: 0.88rem;
  color: var(--d-green);
  font-family: var(--d-font-mono);
  font-weight: 600;
}

.delta-texto {
  color: var(--d-green);
  font-weight: 800;
  font-size: 0.95rem;
}

.badge-criticidad {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 800;
}

.badge-criticidad.alta {
  background-color: #cc3636;
  color: #fff;
}

.badge-criticidad.media {
  background-color: #d48804;
  color: #fff;
}

.badge-criticidad.baja {
  background-color: #788843;
  color: var(--d-cream);
}


.btn-circular {
  background: white;
  border: 1px solid var(--d-green);
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-circular:hover {
  background-color: rgba(96, 108, 56, 0.1);
}

.pagination-wrapper {
  border-top: 1px solid rgba(64, 34, 8, 0.1);
  background-color: rgba(96, 108, 56, 0.05);
}

.btn-pag {
  background: white;
  border: 1px solid var(--d-green);
  color: var(--d-brown);
  border-radius: 8px;
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-pag:hover:not(:disabled) {
  background-color: var(--d-green);
  color: var(--d-cream);
}

.btn-pag:disabled {
  opacity: 0.35;
  cursor: default;
}

.divisan-modal {
  background-color: var(--d-cream);
  border: 2px solid var(--d-brown);
  border-radius: 20px;
}

.label-divisan {
  color: var(--d-brown);
  font-weight: 700;
}

.divisan-input-modal {
  border: 1px solid var(--d-green);
  border-radius: 8px;
}

.divisan-mobile-card {
  background-color: var(--d-cream);
  border-radius: 15px;
  border-left: 6px solid var(--d-green);
}

.detalle-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.detalle-mini-label {
  font-size: 0.7rem;
  font-weight: 800;
  text-transform: uppercase;
  color: var(--d-green);
  display: block;
  margin-bottom: 2px;
}

.detalle-mini-valor {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--d-brown);
}

.detalle-seccion {
  border-top: 1px solid rgba(96, 108, 56, 0.2);
  padding-top: 10px;
}

/* ── Archivos existentes en edición ── */
.archivo-existente {
  background: rgba(96, 108, 56, 0.08);
  border-radius: 8px;
  border: 1px solid rgba(96, 108, 56, 0.2);
}

.btn-quitar {
  background: none;
  border: 1px solid #a32d2d;
  color: #a32d2d;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 2px 8px;
  cursor: pointer;
  transition: all 0.15s;
}

.btn-quitar:hover {
  background-color: #a32d2d;
  color: #fff;
}

/* ── Paginación móvil ── */
.pagination-mobile {
  border-top: 1px solid rgba(64, 34, 8, 0.15);
}

.btn-pag-mobile {
  background: var(--d-cream);
  border: 1px solid var(--d-green);
  color: var(--d-brown);
  border-radius: 10px;
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 110px;
  justify-content: center;
}

.btn-pag-mobile:hover:not(:disabled) {
  background-color: var(--d-green);
  color: var(--d-cream);
}

.btn-pag-mobile:disabled {
  opacity: 0.35;
  cursor: default;
}

/* ── Custom dropdown ── */
.custom-select-wrapper {
  position: relative;
}

.custom-select-input {
  padding-right: 2.2rem !important;
}

.criticidad-display {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  min-height: 38px;
}

.custom-select-arrow {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--d-green);
  font-size: 0.8rem;
  cursor: pointer;
}

.custom-dropdown {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  z-index: 1080;
  background: white;
  border: 1.5px solid var(--d-green);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(40, 54, 24, 0.15);
  max-height: 185px;
  overflow-y: auto;
}

.custom-dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  gap: 8px;
  align-items: center;
  border-bottom: 1px solid rgba(96, 108, 56, 0.08);
  transition: background 0.12s;
}

.custom-dropdown-item:last-child {
  border-bottom: none;
}

.custom-dropdown-item:hover,
.custom-dropdown-item.selected {
  background: rgba(96, 108, 56, 0.12);
}

.btn-header {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.modal-form-scrollable {
  display: contents;
}

@media (max-width: 991.98px) {
  .btn-header-texto {
    display: none;
  }
  .btn-header {
    width: 36px;
    height: 36px;
    padding: 0;
    justify-content: center;
    border-radius: 50%;
  }
}

@media (max-width: 768px) {
  .modal-dialog {
    margin: 85px auto 0.5rem !important;
    max-width: calc(100vw - 1rem) !important;
    height: calc(100dvh - 85px - 0.5rem);
    max-height: calc(100dvh - 1rem);
  }

  .modal-dialog-scrollable .modal-content {
    height: 100%;
    max-height: 100%;
    border-radius: 16px !important;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .modal-dialog-scrollable .modal-header,
  .modal-dialog-scrollable .modal-footer {
    flex-shrink: 0;
  }

  .modal-dialog-scrollable .modal-body {
    flex: 1 1 auto;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}

/* ── Paginación unificada ── */
.paginacion-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  flex-wrap: wrap;
  gap: 8px;
  border-top: 1px solid rgba(64, 34, 8, 0.1);
  background: rgba(96, 108, 56, 0.05);
}
.pag-izq {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.pag-der {
  display: flex;
  align-items: center;
  gap: 4px;
}
.pag-info {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--d-green);
  white-space: nowrap;
}
.por-pagina-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}
.por-pagina-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--d-green);
  white-space: nowrap;
}
.por-pagina-select {
  appearance: none;
  -webkit-appearance: none;
  background: white
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%23606c38' d='M0 0l5 6 5-6z'/%3E%3C/svg%3E")
    no-repeat right 8px center;
  border: 1.5px solid var(--d-green);
  border-radius: 8px;
  padding: 3px 26px 3px 10px;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--d-brown);
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s;
  min-width: 58px;
}
.btn-pag-num {
  background: white;
  border: 1.5px solid rgba(96, 108, 56, 0.25);
  color: var(--d-brown);
  border-radius: 8px;
  min-width: 32px;
  height: 32px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.18s;
  font-size: 0.82rem;
  font-weight: 700;
}
.btn-pag-num:hover {
  background: rgba(96, 108, 56, 0.1);
  border-color: var(--d-green);
}
.btn-pag-num.activo {
  background: var(--d-brown);
  color: var(--d-cream);
  border-color: var(--d-brown);
  pointer-events: none;
}
.pag-ellipsis {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 32px;
  font-size: 0.85rem;
  color: var(--d-brown);
  opacity: 0.4;
  font-weight: 700;
}
.paginacion-mobile {
  border-top: 1px solid rgba(64, 34, 8, 0.15);
  padding: 10px 4px;
  margin-top: 4px;
}
.pag-mobile-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}
.pag-mobile-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
